import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Blog from '../../../components/blog/layout-one'
import Swiper, { SwiperSlide } from '../../../components/shared/swiper'
import { truncateString } from '../../../utils/utilFunctions'
import { FeaturePostWrapper } from './feature-post-area.stc'

const sliderSettings = {
	slidesPerView: 1,
	spaceBetween: 30,
	navigation: true,
	autoplay: true,
	autoHeight: true,
	breakpoints: {
		1200: {
			slidesPerView: 3,
		},
		768: {
			slidesPerView: 2,
		},
		320: {
			slidesPerView: 1
		}
	}
}

const FeaturePostArea = () => {
	const featurePostData = useStaticQuery(graphql`
        query FeaturePostQuery {
            allMarkdownRemark(
            	sort: {order: DESC, fields: frontmatter___date},
            	filter: {frontmatter: {is_featured: {eq: true}}}
            ) {
                totalCount
                edges {
                    node {
                        fields {
                            slug
                            dateSlug
                            postID
                        }
                        frontmatter {
                            category
                            date(formatString: "LL")
                            format
                            tags
                            title
                            is_featured
                            video_link
                            quote_text
                            quote_author
                            link
							image {
								childImageSharp {
									gatsbyImageData(width: 510, height: 595, layout: CONSTRAINED, quality: 100, placeholder: TRACED_SVG)
								}
							}
							images {
								childImageSharp {
									gatsbyImageData(width: 510, height: 595, layout: CONSTRAINED, quality: 100, placeholder: TRACED_SVG)
								}
							}
                        }
                    }
                }
            }
        }
    `);
	const blogs = featurePostData.allMarkdownRemark.edges;
	return (
		<FeaturePostWrapper id="feature-post">
			<Container>
				<Row>
					<Col lg={12}>
						<div className="feature-post-slider">
							<Swiper options={sliderSettings} navStyle={2}>
								{blogs.map(blog => (
									<SwiperSlide className="item" key={blog.node.fields.slug}>
										<Blog
											content={{
												...blog.node.fields,
												...blog.node.frontmatter,
												title: truncateString(blog.node.frontmatter.title, 35)
											}}
										/>
									</SwiperSlide>
								))}
							</Swiper>
						</div>
					</Col>
				</Row>
			</Container>
		</FeaturePostWrapper>
	)
}

export default FeaturePostArea
